import { FlexColumn, FlexRow } from '@gorila-shared-ui/components';
import { Block } from 'baseui/block';
import { useEffect } from 'react';
import { useRecoilState, useSetRecoilState } from 'recoil';
import { ASSET_TYPE_CONTAINER } from '../../constants/asset';
import { useStyles } from '../../hooks/useStyles';
import { selectAssetState } from '../../storage/assets';
import { showTrafficLayerState } from '../../storage/map';
import { Asset } from '../../types/asset';
import { isVehicleLikeType } from '../../utils/assets';
import AssetContainerData from './AssetContainerData';
import AssetCurrentStateWrapper from './AssetCurrentStateWrapper';
import { AssetDataResume } from './AssetDataResume';
import AssetVehicleData from './AssetVehicleData';

type Props = {
  asset: Asset;
};

export function AssetInfo({ asset }: Readonly<Props>) {
  const setSelectAsset = useSetRecoilState(selectAssetState);
  const { css, classes, concatenateClasses, theme } = useStyles();
  const [showTrafficLayer, setShowTrafficLayer] = useRecoilState(showTrafficLayerState);

  useEffect(() => {
    if (showTrafficLayer) setShowTrafficLayer(false);
    if (!asset) {
      setSelectAsset(undefined);
      return;
    }
    setSelectAsset(asset);
  }, [asset]);

  const columnWrapperStyles = concatenateClasses(classes.flexible(1), css({ width: '100%' }));

  return (
    <FlexColumn
      classNames={css({
        flex: 1,
      })}
    >
      <FlexRow
        breakPoint="isMedium"
        classNames={css({ alignItems: 'start' })}
      >
        <FlexColumn
          classNames={columnWrapperStyles}
          gap={theme.sizing.scale600}
        >
          <AssetDataResume
            asset={asset}
            withDevices={false}
          />
        </FlexColumn>
        <Block className={columnWrapperStyles}>
          {asset.vehicle && isVehicleLikeType(asset.assetType) && (
            <AssetVehicleData
              vehicle={asset.vehicle}
              assetType={asset.assetType}
            />
          )}
          {asset.container && asset.assetType === ASSET_TYPE_CONTAINER && (
            <AssetContainerData container={asset.container} />
          )}
        </Block>
      </FlexRow>
      <AssetCurrentStateWrapper asset={asset} />
    </FlexColumn>
  );
}
